import { SortDirection } from "../enums/general"

export enum PageModule {
  /** Display text (without an action) */
  Static = "static",

  /** Allow the patient to book an appointment */
  AppointmentCreation = "appointmentCreation",

  /** Allow the patient to list all their appointments known in the HIS */
  AppointmentList = "appointmentList",

  /** Allow the patient to book an e-consult (digital consult) */
  Econsult = "econsult",

  /** Walk in consult feature (digital consults without prior booking at specific time slots) */
  WalkInConsult = "walkInConsult",

  /** Allow the patient to request repeat prescriptions through a form*/
  MedicationRequest = "medicationRequest",

  /** Allow patients to register at the practice */
  RegistrationRequest = "registrationRequest",

  /**
   * The "medical file" sub-pages. This allows a patient to view their medical files.
   * This is an important feature for us, because it allows practices to replace
   * their entire patient portal for ours.
   *
   * What is available depends on the HIS, but typically includes overview of
   * "complaints/illness", "medication history", "lab results", "allergies", and
   * "correspondence with GPs and referral letters"
   */
  MyMedicalFile = "myMedicalFile",
}

/**
 * The `PagePrep` affects whether Plato is used for patient triage
 *
 * NOTE: This is only relevant for the page modules `AppointmentCreation` and
 * `Econsult`
 */
export enum PagePrepConfig {
  /**
   * Plato disabled.
   * Patients can make an appointment by choosing a time slot directly.
   */
  Disabled = "disabled",

  /** Plato is enabled. Alternative contact methods are not suggested. */
  UrgentOnly = "urgentOnly",

  /** Plato is enabled. Suggests alternative contact methods. Allow e-consult even if digital contact is not recommended. */
  DisplayAdvise = "displayAdvise",

  /** Plato is enabled. Suggests alternative contact methods. Force patient to book a face-to-face appointment if digital contact is not recommended. */
  ForceAdvise = "forceAdvise",
}

export const MIN_LIMIT = 1
export const MAX_LIMIT = 100
export const DEFAULT_SORT_DIR = SortDirection.ASC
